//
//
//
//
//
//

export default {
  name: 'swipeout'
}



// WEBPACK FOOTER //
// ./~/vux/src/components/swipeout/swipeout.vue